import { Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { TypographyVariant } from "@mui/material/styles/createTypography";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { IconButtonClose } from "components/iconButtons";
import * as React from "react";
import { MprcTextMuted } from "./MprcTextMuted";

interface IProps {
    children?: React.ReactNode;
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    typographyVariant?: TypographyVariant;
    onClose?: () => void;
}

interface IStyleProps {
    shrinkPadding?: boolean;
}

const StyledDialogTitle = styled(
    "div",
    { shouldForwardProp: (propName: string) => propName != "shrinkPadding" }
)<IStyleProps>(
    ({ theme, shrinkPadding }) => ({
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(2),
        paddingBottom: shrinkPadding ? 0 : theme.spacing(3),
    })
);

type Props = IProps & IStyleProps;

export const MprcDialogTitleClose: React.FC<Props> = (props) => {
    const { children, title, subtitle, typographyVariant, shrinkPadding, onClose } = props;
    return (
        <StyledDialogTitle shrinkPadding={shrinkPadding}>
            <Grid container wrap="nowrap" direction="row" justifyContent="space-between" alignItems="flex-start">
                <Grid size="grow">
                    <Typography noWrap variant={typographyVariant ?? "h2"}>{title}</Typography>
                    {
                        subtitle && typeof (subtitle) == "string"
                            ? <Typography noWrap={true} variant="body2">{subtitle}</Typography>
                            : <MprcTextMuted>{subtitle}</MprcTextMuted>
                    }
                </Grid>
                {
                    onClose &&
                    <Grid>
                        <IconButtonClose
                            size="small"
                            className={AppGlobalClassKeys.clickable}
                            onClick={onClose}
                        />
                    </Grid>
                }
            </Grid>
            {children}
        </StyledDialogTitle >
    );
};
